<template>
  <div class="col s12 center">

    <h3 v-show="stageHasContent" class="vert-offset-top-2">{{ stage }}</h3>
    <div v-show="isStreaming" class="col s12">
      <video id="camera__view" ref="camera__view" autoplay playsinline></video>
      <canvas id="camera__sensor" ref="camera__sensor"></canvas>
      <img src="//:0" alt="" id="camera__output" ref="camera__output" />
      <button id="trigger" type="button" class="btn btn-large grey darken-3" @click.prevent="capture">Take a Pic</button>
    </div>

    <div v-show="!isStreaming && picture.taken && !submit_report" class="col s12 center">
      <div id="snapshot" ref="snapshot" class="col s12"></div>

      <div class="col s12 vert-offset-top-1 center">
        <div class="col s10 offset-s1 vert-offset-top-half row vert-offset-bottom-half">

          <Inputcomponent  id="summary" type="text" v-model="submitInput" label="Write Additional Information" data-length="200"/>
        </div>
        <button  class="btn-large grey darken-2 margin-left-half margin-right-half vert-offset-top-half"
                 :disabled="!canSubmit"
                 @click="startStreaming"
        >
          Take Another Picture
        </button>
        <button class="btn-large grey darken-2 margin-left-half margin-right-half vert-offset-top-half"
                :disabled="!canSubmit"
                @click="submitcomplete"
        >
          Report
        </button>
      </div>
    </div>


    <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3 padding-top-1 padding-bottom-1 vert-offset-top-2 center" v-show="submit_report == true">
      <h5>Your Report was submitted successfully. Thank you for your support!</h5>
      <div class="col s12 padding-top-half font-12 vert-offset-top-1 border-top-1 grey-border border-lighten-2">
        You will be redirected in <span class="font-bold">{{ timer }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Inputcomponent from "@/components/materialize/InputComponent"
import http from "../http-common"
import {mapState} from "vuex"
export default {
  name: 'TakePic',
  components:{
    Inputcomponent
  },
  data() {
    return {
      constraints : {
        video: {
          facingMode: "environment"
        }
      },
      stage: "",
      canStream: false,
      takePicture: false,
      cameraOutput: {},
      cameraView: {},
      cameraSensor: {},
      cameraTrigger: {},
      objStream: null,
      mediaMgr: null,
        snapshot_content: {},
        canSubmit : true,
        isStreaming: false,

        picture : {
            dataUrl : null,
            blob: null,
            taken:false
        },
        submitInput:"",
        submit_report:false,
        timer: 10,
        country:"BW"

    };
  },
  created()
  {


  },
  mounted()
  {
      let _thisObject = this;
      _thisObject.cameraOutput = _thisObject.$refs.camera__output;
      _thisObject.cameraSensor = _thisObject.$refs.camera__sensor;
      _thisObject.cameraView = _thisObject.$refs.camera__view;
      _thisObject.snapshot_content = _thisObject.$refs.snapshot;

    if(typeof window.navigator === "undefined" || window.navigator === null || typeof window.navigator.mediaDevices === "undefined" || window.navigator.mediaDevices === null)
    {
        _thisObject.stage = 2;
      _thisObject.stage = "There seem to be a problem with the browser you are using, please try a different one.";
      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
      return false;
    }


    if(typeof window.navigator.mediaDevices.getUserMedia === "undefined" || window.navigator.mediaDevices.getUserMedia === null)
    {
      _thisObject.stage = "MediaDevices Access Not Allowed on this browser, please try a different browser.";
      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
      return false;
    }

    _thisObject.canStream = true;
      _thisObject.startStreaming();

  },
  methods: {
      capture: function()
      {
          while (this.snapshot_content.firstChild) {
              this.snapshot_content.removeChild(this.snapshot_content.firstChild);
          }
          this.cameraSensor.width = this.cameraView.videoWidth;
          this.cameraSensor.height = this.cameraView.videoHeight;
          let context = this.cameraSensor.getContext("2d");
          /*context.scale(-1, 1);
          context.drawImage(this.cameraView, 0, 0, this.cameraSensor.width*-1, this.cameraSensor.height);*/
          context.drawImage(this.cameraView, 0, 0, this.cameraSensor.width, this.cameraSensor.height);
          console.log("Image drawn");
          let _objImage = new Image();
          _objImage.src = this.cameraSensor.toDataURL("image/jpeg");
          _objImage.className = "responsive-img";
          _objImage.width = this.cameraSensor.width;
          _objImage.height = this.cameraSensor.height;
          this.snapshot_content.append(_objImage);
          this.picture.dataUrl = this.cameraSensor.toDataURL("image/jpeg");
          this.picture.blob = this.dataURItoBlob(this.picture.dataUrl);
          console.log(JSON.stringify(this.picture.dataUrl));
          this.picture.taken = true;
          this.stopStreaming();
      },
      startStreaming: function()
      {
          let _thisObject = this;
          if(!_thisObject.canStream)
          {
              _thisObject.stage = "There seem to be an issue with your Camera.";
              _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
              return false;
          }

          _thisObject.cameraOutput.src = "//:0";
          _thisObject.cameraSensor.getContext("2d").clearRect(0, 0, _thisObject.cameraSensor.width, _thisObject.cameraSensor.height);
          _thisObject.takePicture = false;
          _thisObject.stage = "We would like to access your Camera to proceed. Please allow us to Continue.";
          _thisObject.$store.dispatch("START_PROCESSING");
          window.navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }).then(function(stream) {
            /* use the stream */
              _thisObject.stage = "";
              _thisObject.canStream = true;
              _thisObject.objStream = stream;
              _thisObject.cameraView.srcObject = _thisObject.objStream;
              _thisObject.isStreaming = true;
              _thisObject.$store.dispatch("STOP_PROCESSING");
          })
              .catch(function(err) {
                /* handle the error */
                  console.log(err); /* handle the error */
                  if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError")
                  {
                      _thisObject.stage = "No Camera Found.";
                      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
                      //required track is missing
                  } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
                      _thisObject.stage = "Your Camera being used by another App.";
                      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
                      //webcam or mic are already in use
                  } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
                      _thisObject.stage = "The requested Camera configuration cannot be satisfied by this device.";
                      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
                      //constraints can not be satisfied by avb. devices
                  } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
                      _thisObject.stage = "Browser permission denied";
                      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
                      //permission denied in browser
                  } else if (err.name == "TypeError" || err.name == "TypeError") {
                      //empty constraints object
                      _thisObject.stage = "There is an issue with the constraint.";
                      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
                  } else {
                      //other errors
                      _thisObject.stage = "An error occurred, please try again later.";
                      _thisObject.$store.dispatch("GET_MESSAGES", [_thisObject.stage]);
                  }
              });
      },
      stopStreaming()
      {
          if(null !== this.objStream)
          {
              this.cameraView.srcObject = null;
              this.objStream.getTracks().forEach(function(track) {
                  track.stop();
              });

              this.objStream = null;
              this.isStreaming = false;
          }
      },
      dataURItoBlob( dataURI )
      {
          let byteString = atob( dataURI.split( ',' )[ 1 ] );
          let mimeString = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];

          let buffer	= new ArrayBuffer( byteString.length );
          let data	= new DataView( buffer );

          for( let i = 0; i < byteString.length; i++ ) {
              data.setUint8( i, byteString.charCodeAt( i ) );
          }

          return new Blob( [ buffer ], { type: mimeString } );
      },
      prepareReload()
      {
          setTimeout(() => {
              this.$store.dispatch("START_PROCESSING");
              window.location.reload();
          }, 10000);
          setInterval(() => this.timer--, 1000);
      },
      submitcomplete()
      {
          this.canSubmit = false;
          this.$store.dispatch("START_PROCESSING");
        /*var _formData = new FormData();
         _formData.append('action', (this.report_liquor_outlet?1:0));
         _formData.append('district', this.selected_district);
         _formData.append('town', this.selected_town);
         _formData.append('ward', this.selected_ward);
         _formData.append('location', this.selected_location);
         _formData.append('offences', this.offence);
         _formData.append('outlet', this.selected_outlet);
         _formData.append('type', this.selected_location_types);
         _formData.append('image', this.picture.blob);
         _formData.append('message', this.submitInput);
         _formData.append('mobile', this.phone);*/


          window.console.log(JSON.stringify(this.selected_district));

          return new Promise(resolve => {
              http({
                  url: "/tipoffs/save",
                  data: {
                      action: (this.report_liquor_outlet?1:0),
                      offences: this.offence,
                      ward: this.selected_ward,
                      message: this.submitInput,
                      type: this.selected_location_types,
                      location: this.selected_location,
                      town: this.selected_town,
                      district: this.selected_district,
                      outlet: this.selected_outlet,
                      image: this.picture.dataUrl,
                      mobile: this.phone,
                      country:this.country
                  },
                  method: "POST",
                  timeout: 30000 })
                  .then(resp => {
                      this.$store.dispatch("STOP_PROCESSING");

                      this.submit_report = true;
                      this.$store.dispatch("GET_MESSAGES", ["Tip-Off Succesfully recorded."]);

                      this.prepareReload();
                      resolve(resp);
                  })
                  .catch(response => {
                      this.canSubmit = true;
                      console.log("ErrResponse: " + JSON.stringify(response));
                      console.log("Response:" + JSON.stringify(response));
                      console.log("data:" + JSON.stringify(response.data));
                      this.$store.dispatch("STOP_PROCESSING");
                      this.$store.dispatch("GET_MESSAGES", response.data.messages);

                  });

          });
        /*this.submitInput ="";
         e.preventDefault();
         this.submit_report = true;
         this.prepareReload();*/

      },
  },
  computed: {
      stageHasContent: function()
      {
          return (typeof this.stage !== "undefined" && this.stage !== null && this.stage.length > 0);
      },
    ...mapState({
      report_liquor_outlet: state => state.report_liquor_outlet,
      selected_location_types: state => state.selected_location_types,
      selected_town: state => state.selected_town,
      selected_district: state => state.selected_district,
      selected_ward: state => state.selected_ward,
      selected_location: state => state.selected_location,
      selected_outlet: state => state.selected_outlet,
      offence: state => state.offence,
      phone: state => state.phone
    }),
  },
}
</script>
<style>
#camera__output, #camera__sensor, #camera__view
{
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/*#camera__output, #camera__sensor, #camera__view
{
  transform: scaleX(-1);
  filter: FlipH;
}*/
#trigger
{
  width: 200px;
  background-color: #424242 !important;
  color: white;
  font-size: 16px;
  border-radius: 30px;
  border: none;
  /*padding: 15px 20px;*/
  text-align: center;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.2);
  position: fixed;
  bottom:30px;
  right: 30px;
}
</style>